import React, { useState } from 'react';
import { Card, Form, Select, Switch, Typography } from 'antd';

export interface BenchmarkRadarConfig {
  fields: string[];
  showChildren: boolean;
}

const DEFAULT_BENCHMARK_RADAR_CONFIG: BenchmarkRadarConfig = {
  fields: ['average'],
  showChildren: true,
};

interface Props {
  initialConfig?: Partial<BenchmarkRadarConfig>;
  fieldOptions?: Array<{ label: string; value: string }>;
  onChange: (config: BenchmarkRadarConfig) => void;
}

export const SectionConfigBenchmarkRadar: React.FC<Props> = ({ initialConfig, fieldOptions, onChange }) => {
  const [config, setConfig] = useState<BenchmarkRadarConfig>({
    ...DEFAULT_BENCHMARK_RADAR_CONFIG,
    ...initialConfig,
  });

  const selectedField = Array.isArray(config.fields) && config.fields.length > 0
    ? config.fields[0]
    : undefined;

  const handleFieldChange = (value?: string) => {
    const nextConfig = {
      ...config,
      fields: value ? [value] : [],
    };
    setConfig(nextConfig);
    onChange(nextConfig);
  };

  const handleChildOverlayToggle = (checked: boolean) => {
    const nextConfig = {
      ...config,
      showChildren: checked,
    };
    setConfig(nextConfig);
    onChange(nextConfig);
  };

  return (
    <Card size="small" style={{ background: '#f5f5f5' }}>
      <Form.Item label="Aggregation used for benchmark score">
        <Select
          allowClear
          options={fieldOptions || []}
          value={selectedField}
          onChange={handleFieldChange}
        />
      </Form.Item>
      <Form.Item label="Compare child areas (overlay)">
        <Switch checked={config.showChildren} onChange={handleChildOverlayToggle} />
      </Form.Item>
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        Turn this on to overlay all child areas in one spider chart for direct comparison.
      </Typography.Text>
      <br />
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        1 is plotted at the center (Poor) and 5 at the outside (Perfect).
      </Typography.Text>
    </Card>
  );
};

export default SectionConfigBenchmarkRadar;
